(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["be-gallery-sync"]) return;
  try {
    
  function beGalleryVariants(picker) {
    const config = document.querySelector('[data-be-gallery-variants="' + picker.dataset.productId + '"]');
    if (!config) return [];
    try { return JSON.parse(config.textContent); } catch { return []; }
  }
  function beApplyGalleryVariant(picker, variant) {
    let changed;
    variant.options.forEach((value, index) => {
      const input = Array.from(picker.querySelectorAll('input[type="radio"]')).find(el => Number(el.dataset.fieldsetIndex) === index && el.value === value);
      if (input) {
        picker.updateSelectedOption(input);
        input.dataset.variantId = String(variant.id);
        changed = input;
      }
    });
    return changed;
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const thumbnail = event.target.closest('.slideshow-controls__thumbnail');
    if (!thumbnail) return;
    const section = thumbnail.closest('.shopify-section');
    const picker = section?.querySelector('variant-picker');
    const image = thumbnail.querySelector('img');
    if (!picker || !image) return;
    const file = url => String(url || '').split('?')[0].split('/').pop();
    const variants = beGalleryVariants(picker);
    const matches = variants.filter(variant => file(variant.featured_image?.src) === file(image.getAttribute('src')));
    if (!matches.length) return;
    const checked = Array.from(picker.querySelectorAll('input[type="radio"]:checked'));
    const variant = matches.find(item => checked.every(el => item.options[Number(el.dataset.fieldsetIndex)] === el.value)) || matches[0];
    const input = beApplyGalleryVariant(picker, variant);
    if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
